// Page Builder 2026 — Steps block
//
// Tab behaviour for the step timeline: clicking (or arrowing between) the
// nav items swaps the matching panel, and nav items before the active one get
// .is-done so their connector lines show as progress. Optional auto-advance
// (data-steps-auto-advance="seconds") cycles through the steps and stops for
// good on the first user interaction, or entirely for prefers-reduced-motion.
//
// Panels toggle via [hidden]; CSS keeps them display:block on desktop so
// opacity can crossfade at the block's fixed height.

document.querySelectorAll('[data-steps-block]').forEach((block) => {
  const tabs = Array.from(block.querySelectorAll('[data-steps-nav]'));
  const panels = Array.from(block.querySelectorAll('.block-steps__panel'));

  if (tabs.length < 2 || tabs.length !== panels.length) {
    return;
  }

  let current = 0;
  let timer = null;

  // Stretched (5+ step) navs replace per-item connectors with one continuous
  // track; the teal fill runs to the active dot's center.
  const track = block.querySelector('.block-steps__track');
  const progress = block.querySelector('.block-steps__track-progress');

  const updateProgress = () => {
    if (!track || !progress) {
      return;
    }

    const dot = tabs[current].querySelector('.block-steps__dot');

    if (!dot || !dot.offsetParent) {
      return;
    }

    const trackRect = track.getBoundingClientRect();
    const dotRect = dot.getBoundingClientRect();

    progress.style.width = `${Math.max(0, dotRect.left + dotRect.width / 2 - trackRect.left)}px`;
  };

  const activate = (index) => {
    current = (index + tabs.length) % tabs.length;

    tabs.forEach((tab, i) => {
      tab.classList.toggle('is-active', i === current);
      tab.classList.toggle('is-done', i < current);
      tab.setAttribute('aria-selected', i === current ? 'true' : 'false');
      tab.tabIndex = i === current ? 0 : -1;
    });

    panels.forEach((panel, i) => {
      panel.hidden = i !== current;
    });

    updateProgress();
  };

  const stopAutoAdvance = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => {
      stopAutoAdvance();
      activate(i);
    });

    tab.addEventListener('keydown', (event) => {
      const move = { ArrowRight: 1, ArrowLeft: -1 }[event.key];

      if (!move) {
        return;
      }

      event.preventDefault();
      stopAutoAdvance();
      activate(current + move);
      tabs[current].focus();
    });
  });

  const seconds = parseInt(block.dataset.stepsAutoAdvance, 10);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (seconds > 0 && !reducedMotion.matches) {
    timer = setInterval(() => activate(current + 1), seconds * 1000);
  }

  // Initial fill (PHP marks step one active), and re-measure on resize since
  // the fill is a measured px width.
  updateProgress();
  window.addEventListener('resize', updateProgress);
});
